import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import kotLogo from "../../images/logo/kot-logo-white.png";
import companyLogo from "../../images/logo/company-logo.png";
import MobileMenu from "../MobileMenu/MobileMenu";
import { navMenus, headerCta } from "./navData";
import { MegaMenuCompanies, MegaMenuPrograms } from "./MegaMenus";
import { siteConfig } from "../../siteConfig";

// Company site par uska apna logo (generator company-logo.png overwrite karta hai);
// dark-text logos ke liye white chip background.
const isCompanySite = !!siteConfig.entitySlug;
const logo = isCompanySite ? companyLogo : kotLogo;
// Company site par dark-text logo white chip me; main KOT site (dark theme) par white logo.
const logoStyle: React.CSSProperties = isCompanySite
  ? {
      height: 52,
      width: "auto",
      background: "#fff",
      padding: "8px 14px",
      borderRadius: 10,
    }
  : { height: 48, width: "auto" };

// In titles ke liye simple submenu ki jagah mega menu render hota hai
const megaMenuMap: Record<string, React.FC> = {
  "Corporate Companies": MegaMenuCompanies,
  "Strategic Programs": MegaMenuPrograms,
};

const Header: React.FC = () => {
  const [isSticky, setIsSticky] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const [mobileActive, setMobileActive] = useState(false);
  const lastScrollY = useRef<number>(0);

  useEffect(() => {
    const handleScroll = () => {
      const currentScroll = window.scrollY;

      // Scroll up → show sticky smoothly
      if (currentScroll < lastScrollY.current && currentScroll > 100) {
        setIsSticky(true);
        setTimeout(() => setIsVisible(true), 10); // delay for smooth entrance
      }
      // Scroll down → hide sticky instantly
      else if (currentScroll > lastScrollY.current) {
        setIsVisible(false);
        setTimeout(() => setIsSticky(false), 100); // small delay for hide
      }

      // Reset if near top
      if (currentScroll <= 100) {
        setIsSticky(false);
        setIsVisible(false);
      }

      lastScrollY.current = currentScroll;
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleClick = () => window.scrollTo({ top: 0, behavior: "smooth" });
  const handleSubmit = (e: React.FormEvent) => e.preventDefault();

  return (
    <header
      id="xb-header-area"
      className="header-area header-style--one header-transparent is-sticky"
    >
      <div
        className={`xb-header xb-sticky-stt ${
          isSticky ? "xb-header-area-sticky" : ""
        } ${isVisible ? "xb-header-fixed" : "xb-header-hidden"}`}
      >
        <div className="container mxw-1650">
          <div className="header__wrap ul_li_between">
            {/* Logo */}
            <div className="xb-header-logo">
              <Link to="/" className="logo1" onClick={handleClick}>
                <img src={logo} alt="Logo" style={logoStyle} />
              </Link>
            </div>

            {/* Desktop Menu */}
            <div className="main-menu__wrap navbar navbar-expand-lg p-0">
              <nav className="main-menu collapse navbar-collapse">
                <ul>
                  {navMenus.map((item) => {
                    const MegaMenu = megaMenuMap[item.title];

                    // Mega menu wale items (Corporate Companies / Strategic Programs)
                    if (MegaMenu) {
                      return (
                        <li
                          key={item.id}
                          className="menu-item-has-children megamenu"
                        >
                          <Link to="#">
                            <span>{item.title}</span>
                          </Link>
                          <MegaMenu />
                        </li>
                      );
                    }

                    return (
                      <li
                        key={item.id}
                        className={item.submenu ? "menu-item-has-children" : ""}
                      >
                        <Link
                          to={item.link}
                          onClick={
                            item.link.includes("#") ? undefined : handleClick
                          }
                        >
                          <span>{item.title}</span>
                        </Link>
                        {item.submenu && (
                          <ul className="submenu">
                            {item.submenu.map((sub) => (
                              <li key={sub.id}>
                                <Link
                                  to={sub.link}
                                  onClick={
                                    sub.link !== "#" ? handleClick : undefined
                                  }
                                >
                                  <span>{sub.title}</span>
                                </Link>
                              </li>
                            ))}
                          </ul>
                        )}
                      </li>
                    );
                  })}
                </ul>
              </nav>
            </div>

            {/* CTA Button */}
            <div className="header-btn">
              <Link
                to={headerCta.link}
                className="thm-btn"
                onClick={
                  headerCta.link.includes("#") ? undefined : handleClick
                }
              >
                {headerCta.text}
              </Link>
            </div>

            {/* Mobile Toggle */}
            <div className="header-bar-mobile side-menu d-lg-none">
              <button
                className="xb-nav-mobile"
                onClick={() => setMobileActive(!mobileActive)}
              >
                <i className="far fa-bars"></i>
              </button>
            </div>
          </div>

          {/* Mobile Menu */}
          <div className="xb-header-wrap">
            <div className={`xb-header-menu ${mobileActive ? "active" : ""}`}>
              <div className="xb-header-menu-scroll">
                <div
                  className="xb-menu-close xb-hide-xl xb-close"
                  onClick={() => setMobileActive(false)}
                ></div>

                <div className="xb-logo-mobile xb-hide-xl">
                  <Link to="/" rel="home">
                    <img src={logo} alt="KOT Enterprises" />
                  </Link>
                </div>

                <div className="xb-header-mobile-search xb-hide-xl">
                  <form role="search" onSubmit={handleSubmit}>
                    <input
                      type="text"
                      placeholder="Search..."
                      name="s"
                      className="search-field"
                    />
                    <button className="search-submit" type="submit">
                      <i className="far fa-search"></i>
                    </button>
                  </form>
                </div>

                <nav className="xb-header-nav">
                  <MobileMenu />
                </nav>
              </div>
            </div>
            <div className="xb-header-menu-backdrop"></div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
